"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagGQ = function FlagGQ(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-32.55H-193v-82.39a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V56.91H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "90.45",
    width: "409.6",
    height: "89.44",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-90.52,16.55a7.07,7.07,0,0,0,0-8.75L-191.13-119.63a6.93,6.93,0,0,0-1.87,4.69V139.3a6.93,6.93,0,0,0,1.87,4.69Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.1,18.5c0,.17,0,16.77-4.3,24.94H17.73c-4.24-8.17-4.3-24.77-4.3-24.94,0-5.72,5.93-10.27,6-10.31l-2-2.66a22.48,22.48,0,0,0-4,4.09V5.19H10.1V9.62a21.78,21.78,0,0,0-4-4.09l-2,2.66c.06,0,6,4.59,6,10.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#b46446"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.39-1.46a2.89,2.89,0,0,0-.29,0,5,5,0,0,0-4.69-3.36,5,5,0,0,0-2.18.52,4.15,4.15,0,0,0-3.64-2.19,4.21,4.21,0,0,0-1.29.23,5.82,5.82,0,0,0-5.36-3.55A5.81,5.81,0,0,0,5.19-4.69a5.38,5.38,0,0,0-.9-.09A5.81,5.81,0,0,0-1.53,1a5.78,5.78,0,0,0,.11,1.1A4.91,4.91,0,0,0-4.56,5.23a1.54,1.54,0,0,0-.3,0A3.32,3.32,0,0,0-8.18,8.52a3.32,3.32,0,0,0,3.32,3.32A3.28,3.28,0,0,0-2.66,11a5,5,0,0,0,2.79.84,4.9,4.9,0,0,0,2.49-.69A5,5,0,0,0,10.1,6.86,4.2,4.2,0,0,0,10,6.24a5.82,5.82,0,0,0,2.56.62,5.76,5.76,0,0,0,3.13-.93,5,5,0,0,0,4.36,2.59,4.91,4.91,0,0,0,1.16-.15,4.94,4.94,0,0,0,7.55.11,5,5,0,0,0-.41-9.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.41,2.7a4.4,4.4,0,0,1,.05-.51,4.93,4.93,0,0,1-3.38,1.34A5,5,0,0,1,15.93,1.3a5,5,0,0,1-4.16,2.23A5,5,0,0,1,8.33,2.14,5.82,5.82,0,0,1,2.62,6.86a6,6,0,0,1-.84-.09s0,.06,0,.09a5,5,0,0,1-3.34,4.68,5,5,0,0,0,1.68.3,4.9,4.9,0,0,0,2.49-.69A5,5,0,0,0,10.1,6.86,4.2,4.2,0,0,0,10,6.24a5.82,5.82,0,0,0,2.56.62,5.76,5.76,0,0,0,3.13-.93,5,5,0,0,0,4.35,2.59,4.93,4.93,0,0,0,1.17-.15,4.94,4.94,0,0,0,7.55.11h0a5.8,5.8,0,0,1-5.4-5.78Zm0,0",
    transform: "translate(194 123)",
    fill: "#5fa000"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.77,54a.61.61,0,0,1-.59-.42c-.07-.18-1.63-4.56-7.73-4.56H-4.86a9,9,0,0,1-8.94-8.94V-14.76a.63.63,0,0,1,.63-.62H38.37a.63.63,0,0,1,.63.62V40.11a9,9,0,0,1-8.94,8.94h-10c-6.13,0-7.71,4.52-7.72,4.56a.62.62,0,0,1-.59.43ZM-12.55-14.14V40.11A7.7,7.7,0,0,0-4.86,47.8H3.45c4.94,0,7.33,2.65,8.32,4.24,1-1.59,3.37-4.24,8.31-4.24h10a7.7,7.7,0,0,0,7.69-7.69V-14.14Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.39-29.59,7-27.06l3,.11-1.4,2.63L10-21.69l-3,.11L5.39-19.06,3.81-21.58l-3-.11,1.4-2.63L.83-26.95l3-.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.66-27.29l2.13,2.09,2.92-.6-.75,2.89,2,2.23-2.87.8L-6.2-17l-2.13-2.09-2.92.59.75-2.88-2-2.24,2.87-.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-22.14-23.3l2.53,1.58,2.72-1.21-.1,3,2.41,1.75-2.63,1.4-.32,3-2.53-1.58-2.72,1.22.11-3-2.42-1.76,2.64-1.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.21-29.59l-1.58,2.53-3,.11,1.4,2.63-1.4,2.63,3,.11,1.58,2.52,1.58-2.52,3-.11-1.4-2.63,1.4-2.63-3-.11Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M32.26-27.29,30.13-25.2l-2.92-.6L28-22.91l-2,2.23,2.87.8L29.8-17l2.13-2.09,2.92.59-.75-2.88,2-2.24-2.88-.79Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M45.74-23.3l-2.53,1.58-2.73-1.21.11,3L38.18-18.2l2.63,1.4.31,3,2.53-1.58,2.73,1.22-.11-3,2.41-1.76-2.63-1.4Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagGQ;
exports["default"] = _default;